import React from 'react';
import { Download, PlayCircle, RefreshCw, Clock } from 'lucide-react';
export function HowItWorksSection() {
  return <section className="py-20 bg-[#060919] relative border-t border-white/5" data-id="element-117">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
        <div className="text-center mb-16" data-id="element-119">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-120">
            Tu Liberación en{' '}
            <span className="text-yellow-400" data-id="element-121">3 Pasos Simples</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative mb-20" data-id="element-122">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-transparent via-yellow-500/30 to-transparent -translate-y-1/2 z-0" data-id="element-123"></div>

          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-124">
            <div className="w-20 h-20 bg-[#1a1f3a] border-2 border-yellow-500/50 rounded-full flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(212,175,55,0.2)]" data-id="element-125">
              <Download className="w-8 h-8 text-yellow-400" data-id="element-126" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-127">1. Descarga</h3>
            <p className="text-gray-400 px-4" data-id="element-128">
              Accedes al material y a todos los bonos inmediatamente después de
              tu pago seguro.
            </p>
          </div>

          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-129">
            <div className="w-20 h-20 bg-[#1a1f3a] border-2 border-yellow-500/50 rounded-full flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(212,175,55,0.2)]" data-id="element-130">
              <PlayCircle className="w-8 h-8 text-yellow-400" data-id="element-131" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-132">2. Aplica</h3>
            <p className="text-gray-400 px-4" data-id="element-133">
              Sigues el protocolo diario de 3 días (menos de 30 min al día) para
              limpiar y blindar tu campo.
            </p>
          </div>

          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-134">
            <div className="w-20 h-20 bg-[#1a1f3a] border-2 border-yellow-500/50 rounded-full flex items-center justify-center mb-6 shadow-[0_0_20px_rgba(212,175,55,0.2)]" data-id="element-135">
              <RefreshCw className="w-8 h-8 text-yellow-400" data-id="element-136" />
            </div>
            <h3 className="text-xl font-bold text-white mb-3" data-id="element-137">3. Restablece</h3>
            <p className="text-gray-400 px-4" data-id="element-138">
              Activas la guía de manifestación para recuperar el tiempo perdido
              y atraer lo que deseas.
            </p>
          </div>
        </div>

        {/* Proof / Believability Block */}
        <div className="bg-gradient-to-r from-[#1a1f3a] to-[#0a0e27] border border-yellow-500/30 rounded-3xl p-8 md:p-12 max-w-4xl mx-auto text-center shadow-2xl relative overflow-hidden" data-id="element-139">
          <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-500/10 rounded-full blur-[80px]" data-id="element-140"></div>

          <div className="inline-flex items-center justify-center space-x-2 mb-6 bg-yellow-500/10 px-4 py-2 rounded-full border border-yellow-500/20" data-id="element-141">
            <Clock className="w-5 h-5 text-yellow-400" data-id="element-142" />
            <span className="text-yellow-400 font-bold tracking-wide" data-id="element-143">
              LO QUE CAMBIA EN 72 HORAS
            </span>
          </div>

          <p className="text-xl md:text-2xl text-gray-200 leading-relaxed italic mb-6" data-id="element-144">
            "Al completar el Tercer Día, notarás que el 'ruido mental'
            desaparece, tu cuerpo físico se siente liviano y las oportunidades
            que estaban trabadas comienzan a fluir naturalmente."
          </p>

          <p className="text-yellow-400 font-bold text-lg" data-id="element-145">
            No es magia, es orden energético.
          </p>
        </div>
      </div>
    </section>;
}